<!-- vehicle-config.component.html -->
<div class="container row">
  <app-config-line
    [title]="'Preferencias panel de Geocercas'"
    [titleLevel]="7"
    [withHr]="false"
    [sectionReturn]="configSections.VIEWS_PREFERENCES"
    [render]="!filterOptionsBy"
  >
  </app-config-line>

  <app-config-line
    [title]="'Vista por defecto'"
    [description]="'Mostrar las geocercas en una tabla o como una lista por operación'"
    [filterBy]="filterOptionsBy"
  >
    <p-dropdown 
      [options]="options" 
      [(ngModel)]="geofenceService.configuration.viewSelected"
      [appendTo]="'body'" 
      [placeholder]="'Selecciona vista'" 
      optionLabel="label" 
      optionValue="value"
      [style]="{'width':'200px'}">
    </p-dropdown>
  </app-config-line>
  
  <app-config-line
    [title]="'Filtro de vistas'"
    [description]="'Muestra u oculta el control de vistas de geocercas (por operación o vista general).'"
    [filterBy]="filterOptionsBy"
  >
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [(ngModel)]="geofenceService.configuration.options.showFilterView"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line
    [title]="'Crear geocerca'"
    [description]="'Habilita la opción para añadir nuevas geocercas en forma de círculos o polígonos.'"
    [filterBy]="filterOptionsBy"
  >
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [(ngModel)]="geofenceService.configuration.options.createGeocerca"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line
    [title]="'Crear etiqueta'"
    [description]="'Permite agregar etiquetas personalizadas para organizar y clasificar las geocercas.'"
    [filterBy]="filterOptionsBy"
  >
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [(ngModel)]="geofenceService.configuration.options.createLabel"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line
    [title]="'Exportar geocercas'"
    [description]="'Activa la opción para exportar geocercas en formatos compatibles como KML o CSV.'"
    [filterBy]="filterOptionsBy"
  >
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [(ngModel)]="geofenceService.configuration.options.exportarGeo"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line
    [title]="'Importar geocercas'"
    [description]="'Habilita la importación de geocercas desde archivos externos previamente guardados.'"
    [filterBy]="filterOptionsBy"
  >
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [(ngModel)]="geofenceService.configuration.options.importGeo"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>


</div>